document.addEventListener("DOMContentLoaded", function () {
    if (typeof Currency === "undefined") {
        console.error("Currency conversion script not found.");
        return;
    }

    var shopCurrency = "CAD"; // Change this to match your store's base currency
    var currencySelector = document.querySelector(".currency-selector");

    if (currencySelector) {
        currencySelector.addEventListener("change", function (event) {
            var newCurrency = event.target.value;
            Currency.convertAll(shopCurrency, newCurrency);
        });
    }

    // Auto-detect browser currency if needed
    var userCurrency = navigator.language || navigator.userLanguage;
    if (userCurrency.includes("USD")) {
        Currency.convertAll(shopCurrency, "USD");
    }
});